import { createFileRoute } from "@tanstack/react-router";
import ManufacturerManager from "@/features/inventory/ManufacturerManager";
import { RequireCapability } from "@/components/require-capability";

export const Route = createFileRoute("/settings/inventory/manufacturers")({
  component: () => (
    <RequireCapability cap="inventory:manage">
      <SettingsManufacturersPage />
    </RequireCapability>
  ),
});

function SettingsManufacturersPage() {
  return (
    <div className="container mx-auto px-4 py-6 flex flex-col grow min-h-0 gap-4">
      <div>
        <h1 className="text-lg font-semibold">Manufacturers</h1>
        <p className="text-sm text-muted-foreground">
          Manage equipment and product manufacturers.
        </p>
      </div>
      <ManufacturerManager onClose={() => {}} />
    </div>
  );
}
